<template>
  <div class="contract-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRule"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'ExpenseRowTable',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        baseTableRule: {},
        tableRule: {},
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenBtn: false,
        ids: [], // 被删除的数据id集合
        expenseNameList: [], // 费用名称
        chargeCycleList: [], // 计费周期
        contractBillStandards: [], // 计费标准
        contractChargeUnit: [], //计费单位
        computedContractChargeUnit: [], // 计算后的计费单位
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'expenseName',
            title: '费用名称',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              events: {
                change: (obj) => this.expenseName(obj.row, obj.row['expenseName'], 'expenseName'),
              },
              options: this.expenseNameList,
            },
            width: 150,
          },
          {
            field: 'expenseStandard',
            title: '计费标准',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              events: {
                change: (obj) =>
                  this.expenseStandard(obj.row, obj.row['expenseStandard'], 'expenseStandard'),
              },
              options: this.contractBillStandards,
            },
            width: 150,
          },
          {
            field: 'chargeUnit',
            title: '计费单位',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              // options: this.computedContractChargeUnit,
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {
                      this.computedContractChargeUnit.find(
                        (item) => item.value == row['chargeUnit']
                      )?.label
                    }
                  </span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <ElSelect value={row.chargeUnit} onChange={(val) => (row['chargeUnit'] = val)}>
                    {row?.chargeUnitList &&
                      row?.chargeUnitList?.map((item) => (
                        <ElOption value={item.value} label={item.label}></ElOption>
                      ))}
                  </ElSelect>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'builtArea',
            title: '计费数量/重量/面积',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
              // events: {
              //   input: (obj) => this.updateCol(obj.row, obj.row['builtArea'], 'builtArea'),
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['builtArea']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['builtArea']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'builtArea')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'chargeUnitPrice',
            title: '计费单价',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
              // events: {
              //   input: (obj) =>
              //     this.updateCol(obj.row, obj.row['chargeUnitPrice'], 'chargeUnitPrice'),
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['chargeUnitPrice']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['chargeUnitPrice']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'chargeUnitPrice')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'totalPrice',
            title: '总价',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
          },
          {
            field: 'chargeCycle',
            title: '计费周期',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.chargeCycleList,
            },
            width: 150,
          },
          {
            field: 'cycleNum',
            title: '服务周期数',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
              // events: {
              //   input: (obj) => this.updateCol(obj.row, obj.row['cycleNum'], 'cycleNum'),
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['cycleNum']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['cycleNum']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'cycleNum')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'eachIssuePrice',
            title: '每期费用',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
        ];
      },
    },
    mounted() {
      this.expenseNameList = this.dictListMap.LeaseContractExpenseName; // 费用名称
      this.expenseNameList = this.expenseNameList.slice(0, this.expenseNameList.length - 1);
      this.chargeCycleList = this.dictListMap.LeaseContractChargeCycle; // 计费周期
      this.contractBillStandards = this.dictListMap.LeaseContractBillStandards; // 计费标准
      this.contractChargeUnit = this.dictListMap.LeaseContractChargeUnit; // 计费单位
      this.computedContractChargeUnit = this.dictListMap.LeaseContractChargeUnit; // 计费单位
    },
    methods: {
      // 下拉框切换
      expenseStandard(row, fieldValue, field) {
        console.log(row, fieldValue, field);
        row['chargeUnit'] = '';
        // TODO 这里硬编码
        row['chargeUnitList'] = this.filterUtil(fieldValue);
      },
      expenseName(row, fieldValue, field) {
        console.log(row, fieldValue, field);
        row['expenseType'] = fieldValue;
        row['expenseName'] = this.expenseNameList.find((item) => item.value == fieldValue)?.label;
      },
      filterUtil(fieldValue) {
        if (fieldValue == '01') {
          // 时间
          return this.contractChargeUnit.filter((item) =>
            ['01', '02', '03', '04', '05'].includes(item.value)
          );
        } else if (fieldValue == '02') {
          // 重量
          return this.contractChargeUnit.filter((item) => ['06', '07'].includes(item.value));
        } else if (fieldValue == '03') {
          // 面积
          return this.contractChargeUnit.filter((item) => ['08'].includes(item.value));
        } else if (fieldValue == '04') {
          // 数量
          return this.contractChargeUnit.filter((item) =>
            ['09', '10', '11', '12'].includes(item.value)
          );
        } else if (fieldValue == '05') {
          // 一口价
          return this.contractChargeUnit.filter((item) => ['13'].includes(item.value));
        }
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field);
        row[field] = fieldValue;
        if (field == 'builtArea') {
          row['totalPrice'] = (
            fieldValue * (row['chargeUnitPrice'] ? row['chargeUnitPrice'] : 0)
          ).toFixed(2);
          row['eachIssuePrice'] = row['cycleNum']
            ? (row['totalPrice'] / row['cycleNum']).toFixed(2)
            : 0;
        } else if (field == 'chargeUnitPrice') {
          row['totalPrice'] = (fieldValue * (row['builtArea'] ? row['builtArea'] : 0)).toFixed(2);
          row['eachIssuePrice'] = row['cycleNum']
            ? (row['totalPrice'] / row['cycleNum']).toFixed(2)
            : 0;
        } else if (field == 'cycleNum') {
          row['eachIssuePrice'] = fieldValue ? (row['totalPrice'] / fieldValue).toFixed(2) : 0;
        }
      },
      handleSelectionChange(row) {
        console.log(row);
        this.selectionList = row.selection;
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 关闭表格
      closeEditTableHandler() {},
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate((valid) => {
            console.log(tableData, '表格数据', valid);
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item) => {
              return {
                ...item,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ tableData: formTableData, deleteExpenseLineIds: this.ids });
            // if (valid && tableData.length) {
            //   const currentStatus = this.$route.query.status;
            //   const formTableData = tableData.map((item) => {
            //     return {
            //       ...item,
            //       departmentCode: this.userInfo.departmentCode,
            //       departmentName: this.userInfo.departmentName,
            //       companyCode: this.userInfo.companyCode,
            //       companyName: this.userInfo.companyName,
            //       // 特殊处理id
            //       id:
            //         ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
            //           ? ''
            //           : item?.id,
            //     };
            //   });
            //   resolve({ tableData: formTableData, deleteSettlementLineIds: this.ids });
            // } else {
            //   this.$message.error('请填写表格数据');
            //   reject({ tableData: [], deleteSettlementLineIds: [] });
            // }
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData.map((item) => {
          return {
            ...item,
            chargeUnitList: this.filterUtil(item.expenseStandard),
          };
        });
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
